<template>
  <FormSection title="Comments">
    <div class="comments-section">
      <div class="comment-field">
        <label>General Comment</label>
        <textarea class="form-control" v-model="form.APF_Comment1" rows="4" placeholder="Enter general comments here..." />
      </div>

      <div class="comment-field">
        <label>PLO Comment</label>
        <textarea class="form-control" v-model="form.APF_Comment2" rows="4" placeholder="Enter PLO comments here..." />
      </div>

      <div class="comment-field">
        <label>Post Review Comment</label>
        <textarea class="form-control" v-model="form.APF_Comment3" rows="4" placeholder="Enter post review comments here..." />
      </div>
    </div>
  </FormSection>
</template>

<script>
import FormSection from './FormSection.vue'

export default {
  name: 'CommentsSection',
  components: {
    FormSection,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.comments-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.comment-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.comment-field label {
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.form-control {
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;
  min-height: 100px;
  font-family: inherit;
}

.form-control:focus {
  outline: none;
  border-color: #426dff;
  box-shadow: 0 0 0 2px rgba(66, 109, 255, 0.2);
}

.form-control::placeholder {
  color: #999;
  font-style: italic;
}
</style>
